<!-- src/views/userhistory.vue -->
<template>
  <div class="user-history-page">
    <h1 class="page-title">История изменений пользователей</h1>

    <!-- Форма фильтров -->
    <div class="filters-section">
      <el-card class="filter-card">
        <div slot="header" class="clearfix">
          <span>Фильтры</span>
        </div>
        <el-form :inline="true" :model="filters" class="filter-form" label-position="top">
          <el-form-item label="Год">
            <el-select v-model="filters.year" placeholder="Выберите год" clearable>
              <!-- ИСПРАВЛЕНО: добавлены пробелы и закрывающие теги -->
              <el-option
                v-for="year in availableYears"
                :key="year"
                :label="year"
                :value="year">
              </el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="Месяц">
            <el-select v-model="filters.month" placeholder="Выберите месяц" clearable>
              <!-- ИСПРАВЛЕНО: добавлены пробелы и закрывающие теги -->
              <el-option
                v-for="(month, index) in monthNames"
                :key="index + 1"
                :label="month"
                :value="index + 1">
              </el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="Тип изменения">
            <el-select v-model="filters.history_type" placeholder="Выберите тип" clearable>
              <el-option label="Все типы" value=""></el-option>
              <el-option label="Создание" value="+"></el-option>
              <el-option label="Изменение" value="~"></el-option>
              <el-option label="Удаление" value="-"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="Имя пользователя">
            <!-- ИСПРАВЛЕНО: добавлены пробелы -->
            <el-input
              v-model="filters.username"
              placeholder="Поиск по имени"
              clearable>
            </el-input>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" @click="applyFilters">Применить</el-button>
            <el-button @click="resetFilters">Сбросить</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>

    <!-- Таблица истории -->
    <div class="table-section">
      <!-- Отладочный вывод для проверки данных -->
      <!-- <p>DEBUG: Загрузка: {{ loading }}</p>
      <p>DEBUG: Всего записей: {{ total }}</p>
      <p>DEBUG: Текущая страница: {{ currentPage }}</p>
      <p>DEBUG: Записи: {{ historyRecords }}</p> -->

      <el-table
        :data="historyRecords"
        style="width: 100%"
        v-loading="loading"
        element-loading-text="Загрузка..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        :default-sort="{prop: 'history_date', order: 'descending'}"
        @sort-change="handleSortChange">
        
        <el-table-column
          prop="history_date"
          label="Дата и время"
          sortable="custom"
          width="180">
          <template v-slot="scope">
            {{ formatDate(scope.row.history_date) }}
          </template>
        </el-table-column>
        
        <el-table-column
          prop="history_user_name"
          label="Кто изменил"
          width="200">
        </el-table-column>
        
        <el-table-column
          prop="username"
          label="Пользователь"
          width="150">
        </el-table-column>
        
        <el-table-column
          prop="history_type"
          label="Тип"
          width="120">
          <template v-slot="scope">
            <el-tag :type="getChangeTypeTag(scope.row.history_type)">
              {{ getChangeTypeName(scope.row.history_type) }}
            </el-tag>
          </template>
        </el-table-column>
        
        <el-table-column
          label="Изменения">
          <template v-slot="scope">
            <div v-if="scope.row.history_type === '+'">
              Новый пользователь создан
            </div>
            <div v-else-if="scope.row.history_type === '-'">
              Пользователь удален
            </div>
            <div v-else>
              <!-- Упрощенный вывод изменений -->
              <ul class="changes-list">
                <li v-for="(value, key) in getSimpleChanges(scope.row)" :key="key">
                  <strong>{{ getFieldLabel(key) }}:</strong> {{ formatSimpleValue(value) }}
                </li>
              </ul>
            </div>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- Пагинация -->
      <div class="pagination-container" v-if="total > 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
// Используем нативный Date для форматирования, чтобы не зависеть от moment
// import moment from 'moment';

export default {
  name: 'UserHistory',
  data() {
    return {
      loading: false,
      historyRecords: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      sortBy: '-history_date', // По умолчанию сортировка по дате, новые первые
      
      // Фильтры
      filters: {
        year: '',
        month: '',
        history_type: '',
        username: ''
      },
      
      // Список доступных лет (например, последние 5 лет)
      availableYears: [],
      
      // Названия месяцев на русском
      monthNames: [
        'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
      ]
    };
  },
  
  created() {
    console.log("Компонент UserHistory создан");
    // Генерируем список лет
    const currentYear = new Date().getFullYear();
    for (let i = currentYear - 5; i <= currentYear; i++) {
      this.availableYears.push(i);
    }
    
    // Загружаем историю при создании компонента
    this.loadHistory();
  },
  
  methods: {
    async loadHistory() {
      console.log("Начало загрузки истории");
      this.loading = true;
      
      try {
        const params = {
          page: this.currentPage,
          page_size: this.pageSize,
          ordering: this.sortBy,
          ...this.filters
        };
        
        // Убираем пустые значения из параметров
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key];
          }
        });
        
        // ВАЖНО: Используем АБСОЛЮТНЫЙ URL API, который мы проверили через Swagger/curl
        // Убедитесь, что этот URL доступен и возвращает JSON
        const response = await axios.get('https://esu.api.ruy.ru/user/users/history/', { params });
        console.log("Ответ от API (полный объект response):", response);
        
        // Проверяем структуру ответа
        if (response.data && Array.isArray(response.data.results)) {
          // Если API возвращает стандартный DRF пагинатор
          this.historyRecords = response.data.results;
          this.total = response.data.count || response.data.results.length;
          console.log("Данные загружены из results:", this.historyRecords.length, "записей. Total:", this.total);
        } else if (response.data && Array.isArray(response.data)) {
          // Если API возвращает просто массив
          this.historyRecords = response.data;
          this.total = response.data.length;
          console.log("Данные загружены из массива:", this.historyRecords.length, "записей. Total:", this.total);
        } else {
          console.error("Неожиданный формат данных от API:", response.data);
          // Обработка ошибки формата данных
          this.historyRecords = [];
          this.total = 0;
        }
      } catch (error) {
        console.error('Ошибка при загрузке истории:', error);
        if (error.response) {
           console.error('Детали ошибки ответа:', error.response.status, error.response.data);
           // В production лучше показывать пользователю уведомление
           // this.$message.error(`Ошибка ${error.response.status}: ${JSON.stringify(error.response.data)}`);
        } else {
           // this.$message.error('Ошибка сети или сервер не отвечает');
        }
        // Очищаем данные в случае ошибки
        this.historyRecords = [];
        this.total = 0;
      } finally {
        console.log("Завершение загрузки истории. Loading:", this.loading, "Total:", this.total);
        this.loading = false;
      }
    },
    
    applyFilters() {
      console.log("Применение фильтров");
      this.currentPage = 1; // Сброс на первую страницу при применении фильтров
      this.loadHistory();
    },
    
    resetFilters() {
      console.log("Сброс фильтров");
      this.filters = {
        year: '',
        month: '',
        history_type: '',
        username: ''
      };
      this.currentPage = 1;
      this.loadHistory();
    },
    
    handleSizeChange(val) {
      console.log("Изменение размера страницы:", val);
      this.pageSize = val;
      this.currentPage = 1;
      this.loadHistory();
    },
    
    handleCurrentChange(val) {
      console.log("Изменение текущей страницы:", val);
      this.currentPage = val;
      this.loadHistory();
    },
    
    handleSortChange({ column, prop, order }) {
      console.log("Изменение сортировки:", prop, order);
      if (order === 'ascending') {
        this.sortBy = prop;
      } else if (order === 'descending') {
        this.sortBy = `-${prop}`;
      } else {
        this.sortBy = '-history_date'; // По умолчанию
      }
      this.loadHistory();
    },
    
    formatDate(dateString) {
      // Используем нативный JavaScript Date для форматирования
      // Формат из API: "28.07.2025 17:40"
      // Преобразуем в стандартный формат для Date
      if (!dateString) return '—';
      const parts = dateString.split(' ');
      if (parts.length !== 2) return dateString; // Неизвестный формат
      const datePart = parts[0].split('.').reverse().join('-'); // 28.07.2025 -> 2025-07-28
      const timePart = parts[1]; // 17:40
      const isoString = `${datePart}T${timePart}`; // 2025-07-28T17:40
      const date = new Date(isoString);
      
      if (isNaN(date.getTime())) {
          // Если не удалось распарсить, возвращаем исходную строку
          return dateString;
      }
      
      // Форматируем в "ДД.ММ.ГГГГ ЧЧ:ММ:СС"
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Месяцы с 0
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      
      return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
    },
    
    getChangeTypeName(type) {
      const types = {
        '+': 'Создание',
        '~': 'Изменение',
        '-': 'Удаление'
      };
      return types[type] || 'Неизвестно';
    },
    
    getChangeTypeTag(type) {
      const tags = {
        '+': 'success',
        '~': 'warning',
        '-': 'danger'
      };
      return tags[type] || 'info';
    },
    
    // Новый метод для упрощенного отображения изменений
    getSimpleChanges(record) {
      // Возвращаем объект с полями, которые мы хотим показать
      // Можно расширить список
      const simpleFields = {};
      if (record.hasOwnProperty('first_name')) simpleFields.first_name = record.first_name;
      if (record.hasOwnProperty('last_name')) simpleFields.last_name = record.last_name;
      if (record.hasOwnProperty('email')) simpleFields.email = record.email;
      if (record.hasOwnProperty('phone')) simpleFields.phone = record.phone;
      if (record.hasOwnProperty('is_active')) simpleFields.is_active = record.is_active;
      // Добавьте другие поля по необходимости
      return simpleFields;
    },

    formatSimpleValue(value) {
      if (value === null || value === undefined) {
        return '—';
      }
      if (typeof value === 'boolean') {
        return value ? 'Да' : 'Нет';
      }
      return String(value);
    },

    getFieldLabel(fieldName) {
      const labels = {
        'username': 'Имя пользователя',
        'first_name': 'Имя',
        'last_name': 'Фамилия',
        'email': 'Email',
        'phone': 'Телефон',
        'patronymic': 'Отчество',
        'is_active': 'Активен',
        'is_staff': 'Персонал',
        'is_superuser': 'Суперпользователь',
        'organization': 'Рег. организация',
        'local_org': 'Местная организация'
      };
      return labels[fieldName] || fieldName;
    }
  }
};
</script>

<style scoped>
.user-history-page {
  padding: 20px;
}

.page-title {
  margin-bottom: 20px;
  color: #303133;
}

.filters-section {
  margin-bottom: 20px;
}

.filter-card {
  border-radius: 4px;
}

.filter-form {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.filter-form .el-form-item {
  margin-bottom: 0;
}

.table-section {
  margin-top: 20px;
}

.changes-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.changes-list li {
  margin-bottom: 5px;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
</style>